import React from "react";
import Header from "../components/Header";
import HeroSection from "../components/webinar/HeroSection";
import CombinedBenefitsSection from "../components/webinar/CombinedBenefitsSection";
import EventDetailsTimerSection from "../components/webinar/EventDetailsTimerSection";
import TrustedBySection from "../components/webinar/TrustedBySection";
import ScalingBarriersSection from "../components/webinar/ScalingBarriersSection";
import BusinessChangeSection from "../components/webinar/BusinessChangeSection";

import WhoShouldAttendNewSection from "../components/webinar/WhoShouldAttendNewSection";
import BonusesSection from "../components/webinar/BonusesSection";
import RegistrationPricingSection from "../components/webinar/RegistrationPricingSection";
import LearningSection from "../components/webinar/LearningSection";

import TestimonialsSection from "../components/webinar/TestimonialsSection";
import FinalQASection from "../components/webinar/FinalQASection";

import FinalCTASection from "../components/webinar/FinalCTASection";
import WebinarFooter from "../components/webinar/WebinarFooter";


const BlankLandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <CombinedBenefitsSection />
      <EventDetailsTimerSection />
      <WhoShouldAttendNewSection />
      <TrustedBySection />
      <ScalingBarriersSection />
      <BusinessChangeSection />
      <LearningSection />
      <TestimonialsSection />
      <BonusesSection />
      <FinalQASection />
      <RegistrationPricingSection />
      <FinalCTASection />     
      <WebinarFooter />
    </div>
  );
};

export default BlankLandingPage;
